function injectStyle (ssrContext) {
  require("!!../../../../../../node_modules/extract-text-webpack-plugin/dist/loader.js?{\"omit\":1,\"remove\":true}!vue-style-loader!css-loader?minimize!../../../../../../node_modules/vue-loader/lib/style-compiler/index?{\"vue\":true,\"id\":\"data-v-5377002e\",\"scoped\":true,\"hasInlineConfig\":true}!stylus-loader!../../../../../../node_modules/vue-loader/lib/selector?type=styles&index=0!./PaginationLayout.vue")
}
var Component = require("!../../../../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!ts-loader!../../../../../../node_modules/vue-loader/lib/selector?type=script&index=0!./PaginationLayout.vue"),
  /* template */
  require("!!../../../../../../node_modules/vue-loader/lib/template-compiler/index?{\"id\":\"data-v-5377002e\",\"hasScoped\":true,\"preserveWhitespace\":false}!../../../../../../node_modules/vue-loader/lib/template-compiler/preprocessor?engine=pug!../../../../../../node_modules/vue-loader/lib/selector?type=template&index=0!./PaginationLayout.vue"),
  /* styles */
  injectStyle,
  /* scopeId */
  "data-v-5377002e",
  /* moduleIdentifier (server only) */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/pages/activities/day/components/paginationlayout/PaginationLayout.vue
// module id = 82bf17ced450d3d7412d
// module chunks = 13